export const bookingRoutes = {
	bookings: (query: string) => `/bookings/${query ? `?${query}` : ''}`,
	bookingsSmsReminder: '/bookings/send_end_reminder_sms/',
	bookingsEmailWelcome: '/bookings/send_welcome_email/',
	bookingsEmailReminder: '/bookings/send_end_reminder_email/',
	bookingsDelete: '/bookings/bulk_delete/',
	bookingsExport: '/bookings/export/',
	bookingsCalendar: (query: string | undefined) =>
		`/bookings/diff_calendar/${query ? `?${query}` : ''}`,
	booking: (id: string) => `/bookings/${id}/`,
	bookingHistory: (id: string) => `/bookings/${id}/history/`,
	bookingMarkAsArrived: (id: string) => `/bookings/${id}/mark_as_arrived/`,
	bookingMarkAsNoShow: (id: string) => `/bookings/${id}/mark_as_no_show/`,
	bookingMarkAsCancelled: (id: string) => `/bookings/${id}/mark_as_cancelled/`,
	bookingMarkAsCompleted: (id: string) => `/bookings/${id}/mark_as_completed/`,
	bookingMarkAsOverdue: (id: string) => `/bookings/${id}/mark_as_overdue/`,
	bookingMarkAsAbandoned: (id: string) => `/bookings/${id}/mark_as_abandoned/`,
	bookingMarkAsTakeDownNotified: (id: string) => `/bookings/${id}/mark_as_takedown_notified/`,
	bookingForceComplete: (id: string) => `/bookings/${id}/force_complete/`,
	bookingMarkAsConfirmed: (id: string) => `/bookings/${id}/mark_as_confirmed/`,
	bookingsProductConfirmEmail: '/bookings/send_product_confirmation_email/',
	bookingsConfirm: '/bookings/products_confirm/',
	bookingsUncofirm: '/bookings/products_unconfirm/',
	bookingProductTransferList: (id: string) => `/bookings/${id}/transferable_target_bookings/`,
	bookingProductTransfer: (id: string) => `/bookings/${id}/transfer_unsold_products/`,
	bookingProductImport: (id: string) => `/bookings/${id}/import_products/`
} as const
